import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml'})

export class safeHtml implements PipeTransform  {

constructor(
    protected sanitizer: DomSanitizer  ) {}

  transform(value) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
    //return this.sanitizer.sanitize(SecurityContext.HTML, value);
  }
}